// extracted by mini-css-extract-plugin
module.exports = {"main":"main_main__3yEB6","fullHeight":"main_fullHeight__iPluP","translucent":"main_translucent__3t43p","active":"main_active__2XmHj","showLogo":"main_showLogo__1QPIV"};